export default {
  basic: {
    name: "Mehul Lakhanpal",
    dob: "09-11-1993",
    profession: "Full stack developer",
    email: "mehullakhanpal@gmail.com",
    city: "Bangalore",
    state: "Karnataka",
    pincode: "560005",
    resumeURL: "",
  },
  timeline: [
    {
      type: "work",
      title: "Nexthink",
      other: "Bangalore",
      tagline: "The Digital Employee Experience Platform",
      subTitle: "Full-Stack Developer",
      startDate: "2024-03-23",
      endDate: "present",
      isOpen: true,
      description: [
        {
          content: [
            "Built and maintained Nexthink.com using Next.js, React, and Hygraph, focusing on performance, SEO, responsiveness, and multi-region localization.",
            "Developed and documented reusable UI components (e.g., Snackbar, LinkedIn Carousel) using Storybook.",
            "Integrated SmartRecruiters with Algolia via Netlify functions and cron jobs.",
            "Set up Vercel + Hygraph monitoring with Teams alerts; resolved GTM tracking issues.",
          ],
        },
      ],
    },
    {
      type: "work",
      title: "Obviously AI",
      other: "Bangalore",
      tagline:
        "A no-code AI platform that enables users to build fast, accurate predictive models and conversational AI tools without writing code",
      subTitle: "Freelancing",
      startDate: "2024-08-12",
      endDate: "2025-01-12",
      isOpen: false,
      description: [
        {
          content: [
            "Set up the foundational Vue 3 codebase, including configuration, ESLint, and Prettier for consistent code quality.",
            "Customized PrimeVue components to match design guidelines, ensuring a polished and cohesive UI.",
            "Designed and built a chat interface for the RAG (Retrieval-Augmented Generation) system, integrated into the core product.",
            "Contributed to improving overall code quality, maintainability, and team development workflows.",
          ],
        },
      ],
    },
    {
      type: "work",
      title: "CoinSwitch",
      other: "Bangalore",
      tagline:
        "CoinSwitch is India’s leading crypto app with over 18 million users",
      subTitle: "Software Development Engineer 3",
      startDate: "2023-02-28",
      endDate: "2024-01-12",
      isOpen: true,
      description: [
        {
          content: [
            "Built a JSON parser to simplify complex JSON for a Server-Driven UI, reducing UI configuration complexity by 10x and minimizing human error by 90%.",
            "Developed the KYC flow and profile section for the Lemonn app using the JSON builder with Node.js and React Native.",
            "Created an AWS Lambda migration script to sync DynamoDB data across multiple environments.",
          ],
        },
      ],
    },
    {
      type: "work",
      title: "Toddle",
      other: "Bangalore",
      tagline:
        "A collaborative teaching platform used by educators worldwide to streamline curriculum planning, teaching, and assessments",
      subTitle: "Senior Product Engineer",
      startDate: "2020-02-03",
      endDate: "2022-11-18",
      isOpen: true,
      description: [
        {
          content: [
            "Revamped user permissions and app settings architecture, ensuring backward compatibility for smooth incremental rollout.",
            "Implemented a global user archiving feature across the frontend while preserving existing user flows.",
            "Developed dynamic forms (e.g., multi-page onboarding) and UI components (e.g., search with tags) driven by JSON configurations.",
            "Built scalable, reusable React components adopted across teams, significantly improving development speed and consistency.",
            "Translated Figma designs into pixel-perfect, production-ready React modules for various platform features.",
          ],
        },
      ],
    },
    {
      type: "work",
      title: "Mobil Biker Cafe",
      tagline:
        "A responsive web application assisting bikers to be updated with the latest offers, events & ideas",
      subTitle: "Freelancing",
      startDate: "2020-07",
      endDate: "2020-09",
      description: [
        {
          content: [
            "Designed and built 80% of the app in one week using React, Node.js, and MySQL (Knex.js).",
            "Provided ongoing support for feature requests and bug fixes to ensure smooth user experience.",
            "Deployed and hosted the application on Microsoft Azure using a virtual machine.",
          ],
        },
      ],
    },
    {
      type: "work",
      title: "Clipboard Health",
      other: "San Francisco",
      tagline:
        "A staffing application to help nurses and hospitals fill part-time shifts",
      subTitle: "Full-Stack Developer",
      startDate: "2019-06-17",
      endDate: "2019-10-04",
      description: [
        {
          content: [
            "Built and shipped multiple full-stack web features using Node.js, React, and MongoDB.",
            "Contributed to cross-platform mobile apps by adding new features with Ionic.",
            "Refactored legacy JavaScript codebase from ES5 to ES6+, improving maintainability and performance.",
          ],
        },
      ],
    },
    {
      type: "work",
      title: "Ideaplunge Solutions",
      other: "India",
      tagline:
        "Service-based consultancy building admin portals and CMS platforms for enterprise clients",
      subTitle: "Frontend developer",
      startDate: "2018-02-01",
      endDate: "2019-12-31",
      description: [
        {
          content: [
            "CDFI: Built a custom drill-down chart feature using amCharts, enabling dynamic chart generation on user interaction.",
            "Essilor & Shimadzu: Developed a reusable modular CMS in Angular 2+ that dynamically rendered UI components and forms from backend JSON configurations.",
            "Designed the CMS architecture to support multiple clients, reducing development overhead and improving scalability.",
            "P&G: Implemented responsive design and cross-browser compatibility (IE, Firefox, etc.) for an internal reporting tool.",
            "Managed report data fetching and state using @ngrx, enhancing performance and maintainability.",
          ],
        },
      ],
    },
    {
      type: "work",
      title: "Net Analytiks",
      other: "India",
      tagline: "A software development consultancy",
      subTitle: "Full-Stack Intern",
      startDate: "2017-08-01",
      endDate: "2017-12-15",
      description: [
        {
          content: [
            "iWish Bids: Developed REST API endpoints using Node.js, Express, and MongoDB for a reverse bidding platform.",
            "Built a feature-rich frontend using vanilla JavaScript, improving UI responsiveness and user interaction.",
            "Initiated the migration to AngularJS for the admin dashboard to enhance maintainability and scalability.",
          ],
        },
      ],
    },
    {
      other: "Bachelor in Computer Science Engineering",
      subTitle: "Visvesvaraya Technological University",
      score: "52.1%",
      title: "T John Institute of Technology",
      endDate: "2016",
    },
    {
      other: "12th Standard",
      subTitle: "Pre University Council",
      score: "56.4%",
      title: "Sri Bhagwan Mahaveer Jain College",
      endDate: "2011",
    },
    {
      other: "10th Standard",
      subTitle: "Indian Certificate of Secondary Examination",
      score: "80%",
      title: "St. Johns High School",
      endDate: "2009",
    },
  ],
  skills: [
    {
      visible: true,
      name: "Node.js",
      highlight: true,
    },
    {
      visible: true,
      name: "CSS3",
      highlight: true,
    },
    {
      visible: true,
      name: "Netlify",
    },
    {
      visible: true,
      name: "Serverless",
    },
    {
      visible: true,
      name: "Redux",
      highlight: true,
    },
    {
      visible: true,
      name: "Express.js",
      highlight: true,
    },
    {
      visible: true,
      name: "React.js",
      highlight: true,
    },
    {
      visible: true,
      name: "Next.js",
    },
    {
      visible: true,
      name: "JavaScript",
      highlight: true,
    },
    {
      visible: true,
      name: "Mantine",
    },
    {
      visible: true,
      name: "Git",
      highlight: true,
    },
    {
      visible: true,
      name: "Tailwind",
    },
    {
      visible: true,
      name: "Ant Design",
    },
    {
      visible: true,
      name: "Styled components",
    },
    {
      visible: true,
      name: "Heroku",
      highlight: true,
    },
    {
      visible: true,
      name: "Webpack",
    },
    {
      visible: true,
      name: "Firebase",
    },

    {
      visible: true,
      name: "Mongoose",
      highlight: true,
    },
    {
      visible: true,
      name: "My SQL",
    },
    {
      visible: true,
      name: "Apollo Client",
      highlight: true,
    },
    {
      visible: true,
      name: "Mongo DB",
      highlight: true,
    },
    {
      visible: true,
      name: "Socket.IO",
    },
    {
      visible: true,
      name: "SCSS",
      highlight: true,
    },
    {
      visible: true,
      name: "GraphQL",
      highlight: true,
    },

    {
      visible: true,
      name: "Mixpanel",
    },
    {
      visible: true,
      name: "Sentry",
    },
    {
      visible: true,
      name: "Github Actions",
    },
    {
      visible: true,
      name: "SendGrid",
    },
    {
      visible: true,
      name: "Figma",
    },
    {
      visible: true,
      name: "HTML5",
    },
    {
      visible: true,
      name: "RxJs",
    },
    {
      visible: true,
      name: "PHP",
    },
    {
      visible: true,
      name: "Angular Material",
    },
    {
      visible: true,
      name: "Angular",
    },
  ],
  social: [
    {
      name: "GITHUB",
      url: "https://github.com/318097",
      classname: "fab fa-github",
      visible: true,
      type: "work",
    },
    {
      name: "HACKEREARTH",
      url: "https://www.hackerearth.com/@ml318097",
      classname: "",
      visible: false,
      type: "work",
    },
    {
      name: "MEDIUM",
      url: "https://medium.com/@ml318097",
      classname: "fab fa-medium",
      visible: true,
      type: "work",
    },
    {
      name: "DEV.TO",
      url: "https://dev.to/ml318097",
      classname: "fab fa-dev",
      visible: true,
      type: "work",
    },
    {
      name: "PRODUCT HUNT",
      url: "https://www.producthunt.com/@ml318097",
      classname: "fab fa-product-hunt",
      visible: true,
      type: "work",
    },
    {
      name: "TWITTER",
      url: "https://twitter.com/ml318097",
      classname: "fab fa-twitter",
      visible: true,
      type: "social",
    },
    {
      name: "LINKEDIN",
      url: "https://www.linkedin.com/in/ml318097/",
      classname: "fab fa-linkedin",
      visible: true,
      type: "social",
    },
  ],
};
